import { TprFolder } from './../tpr-show-files-modal.service';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TprFilesApiService, TprChild } from '../tpr-show-files-modal.service';
import { TreeNode, LazyLoadEvent } from 'primeng/api/primeng-api';
import { ColumnDef, PageOptions } from 'src/app/shared/data-table/data-table.interface';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { CgpConfirmationDialogService } from 'src/app/shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpAlertDialogService, cgpAlertTypes } from 'src/app/shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { DataTableService } from 'src/app/shared/data-table/data-table.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'tpr-email-files',
  templateUrl: './tpr-email-files.component.html',
  styleUrls: ['./tpr-email-files.component.scss']
})
export class TprEmailFilesComponent implements OnInit {


  selectedFolder: string;
  tprToolId: number;
  partNumber: string;
  fixtureNo: string;

  totalEmails: number;
  emails: any[];

  selection: TreeNode[] = [];
  folders: TreeNode[] = [];

  pageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('contactType');

  columns: ColumnDef[] = [
    { field: 'contactType', name: 'Contact Type', editable: false, width: '30%' },
    { field: 'em', name: 'Email', editable: false, width: '50%%' }
  ];

  @ViewChild('emailsTable', { static: true }) emailsTable: DataTableComponent;

  constructor(
    private readonly toastr: ToastrService,
    private readonly cgpConfirmationDialogService: CgpConfirmationDialogService,
    private readonly cgpAlertDialogService: CgpAlertDialogService,
    private readonly dialogRef: MatDialogRef<TprEmailFilesComponent>,
    private readonly tprFilesApiService: TprFilesApiService,
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    private readonly dataTableService: DataTableService
  ) { }

  ngOnInit() {

    this.selectedFolder = this.data.selectedFolder;
    this.tprToolId = this.data.tprToolId;
    this.partNumber = this.data.partNumber;
    this.fixtureNo = this.data.fixtureNo;

    this.tprFilesApiService.getFolders()
      .pipe(map((res: TprFolder[]) =>
        res
          .filter(folder => folder.id !== 'recycleBinId')
          .map(folder => (
            {
              label: folder.text,
              icon: 'fa fa-folder-open',
              data: folder,
              selectable: false,
              expanded: true,
              children: folder.children.map(
                (child: TprChild) => ({
                  label: child.text,
                  icon: 'fa fa-list',
                  data: child,
                  leaf: child.leaf,
                })
              )
            }))))
      .subscribe((res: any) => {
        this.folders = res;

        // Pre-select the first element in the tree
        if (this.folders.length > 0) {
          const first = this.folders
            .map(node => node.children)
            .reduce((prev, cur) => prev.concat(cur), [])
            .find(node => node.leaf);

          this.selection.push(first);
        }
      });
  }

  refreshEmails() {
    this.tprFilesApiService.getContacts(this.tprToolId, this.pageOptions)
      .subscribe((res: any) => {
        this.emails = res.data;
        this.totalEmails = res.totalCount;
      });

    this.emailsTable.selections = [];
  }

  onLazyLoad(event: LazyLoadEvent) {
    this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
    this.pageOptions.size = event.rows;
    this.pageOptions.sort = event.sortField;
    this.pageOptions.page = event.first / this.pageOptions.size;
    this.refreshEmails();
  }

  onTreeSelectionChange(event) {
    this.selection = [event.node];
  }

  send() {
    const folder: TreeNode = this.selection[0];

    if (!folder) {
      this.toastr.error('Please select a folder to send notifications for.');
      return;
    }

    // Get all emails that are unique and not null
    const emails: Set<string> = new Set<string>(
      this.emailsTable.selections
        .map(selection => selection.em)
        .filter(Boolean)
    );

    if (emails.size <= 0) {
      this.toastr.error('Please select at least one Contact Type with a valid email');
      return;
    }

    this.tprFilesApiService.sendNotificationEmail(this.fixtureNo, folder.label, Array.from(emails).join(','))
      .subscribe({
        next: () => {
          this.cgpAlertDialogService.showAlertDialog({
            title: 'Send E-mail',
            message: `The e-mail was sent to '${Array.from(emails).join(',')}'`,
            alert: cgpAlertTypes.success,
            closeLabel: 'Close'
          }).afterClosed().subscribe(() => this.dialogRef.close({ reload: true }));
        },
        error: () => {
          this.cgpAlertDialogService.showAlertDialog({
            title: 'Send E-mail',
            message: 'Failed to send notifcation email.',
            alert: cgpAlertTypes.danger,
            closeLabel: 'Close'
          }).afterClosed().subscribe({ complete: () => this.dialogRef.close({ reload: true }) });
        }
      }
      );
  }

  close() {
    this.dialogRef.close();
  }
}
